














import { defineComponent, computed } from '@vue/composition-api';

import TreemapHub from '@/components/Report/01-Income/TreemapHub.vue';
import incomeByHub from '@/gql/managementReport/01-Income/incomeByHub.gql';

const DeliveryIncomeByHub = defineComponent({
  components: {
    TreemapHub,
  },
  setup() {
    return {
      incomeByHub,
    };
  },
});

export default DeliveryIncomeByHub;
